import { Component, Input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { SharedModule } from "../../shared/modules/shared.module";
import { AuthkitService } from "../../services/authKit.service";

@Component({
  selector: "app-migration-success",
  imports: [SharedModule, TranslatePipe],
  standalone: true,
  templateUrl: "./migration-success.component.html",
  styleUrl: "./migration-success.component.scss"
})
export class MigrationSuccessComponent {
  @Input() email?: string | null;

  constructor(private _authKitService: AuthkitService) { }

  async handleLogin() {
    await this._authKitService.init({ redirectUri: window.location.origin })
    await this._authKitService.signIn({ loginHint: this.email as string })
  };
}
